import React from 'react';
import {useSelector,useDispatch} from 'react-redux';
import * as actionTypes from '../../../redux/actions/actionTypes';
import HeaderStep from '../../../components/HeaderStep/HeaderStep';
import stylesForm from '../Form/Form.module.scss';
import LabelUpload from '../../../components/LabelUpload/LabelUpload';
import { Form, Button } from 'antd';
import styleCaricamentoDocumenti from './CaricamentoDocumenti.module.scss';
import stylesRiepilogo from '../12__Riepilogo/Riepilogo.module.scss';
import Immagine from '../../../components/Immagine/Immagine';
import invioDocumenti from '../../../redux/actions/mock/invioDocumenti';
import confermaDati from '../../../redux/actions/mock/confermaDati';
import {salvaStepOnlyPromise} from '../../../redux/actions/mock/salvaStep';

const CaricamentoDocumenti = () => {

    const datiState = useSelector(state => state.dataReducer || '');
    const datiModello = useSelector(state => state.dataReducer.modello);
    const uuid = useSelector(state => state.dataReducer.modello.id);
    const apiPath = useSelector(state => state.dataReducer.dataApiPath);
    const idDocUploaded = datiState.load.idDocUploaded;
    const loadingConferma = datiState.load.loadingConferma;

    const dispatch = useDispatch();

    function onFinish(values){
        dispatch({type: actionTypes.LOADING_CONFERMA_TRUE});
        dispatch({ type: actionTypes.SALVA_DOCUMENTI, payload: values});
        salvaStepOnlyPromise(datiModello.datiPratica, datiModello.id, datiModello.codiceBroker, datiModello.currentStep, apiPath, datiModello.numPratica)
            .then(res => {
                dispatch({ type: actionTypes.SAVE_DATA, payload: res});
                invioDocumenti(uuid,apiPath).then(() => {
                    dispatch(confermaDati(uuid,apiPath))
                });
            })
            .catch(err => {
                if (err) {
                    dispatch({ type: actionTypes.ERROR_SALVA_STEP, payload: err});
                }
            });
    };
    
    const onFinishFailed = (errorInfo) => {
        console.error(errorInfo)
    };

    return (
        <div className={stylesForm.Form}>

            <HeaderStep titolo='Caricamento documenti' sottotitolo ='' />

            <Form name="step13"  onFinish={onFinish} onFinishFailed={onFinishFailed}>


                <div className={styleCaricamentoDocumenti.PreventivoSuccess}>
                    <div className={styleCaricamentoDocumenti.leftRight}>
                        <div className={styleCaricamentoDocumenti.left}>
                            <Immagine urlImage={'check.png'} name='success' />
                        </div>
                        <div className={styleCaricamentoDocumenti.right}>
                            <h1 className={styleCaricamentoDocumenti.Titolo}>Per la tua sicurezza dobbiamo verificare la tua identità.</h1>
                            <p className={styleCaricamentoDocumenti.Paragrafo}>Utilizza l'upload qui sotto per inviarci il tuo documento di identità.</p>
                            <p className={styleCaricamentoDocumenti.Paragrafo}>Puoi fare una foto del documento o caricare file .pdf, .jpeg, .png di dimensioni inferiori a 3 MB</p>
                        </div>
                    </div>
                </div>
         
                <LabelUpload file='cartaIdentita' />

                <div className={stylesRiepilogo.bottoniRiepilogo}>
                    <Button loading={loadingConferma} htmlType="submit" className={stylesRiepilogo.BottoneAvanti} disabled={!idDocUploaded}>Invia Richiesta <Immagine urlImage={'right.svg'} name='Invia Richiesta' /></Button>
                </div>

            </Form>
        </div>
    )
}

export default CaricamentoDocumenti;